import { APP_NAME } from '@/fixtures/Constants'
import router from '@/router'
import store from '@/store'

export const isUserCanAccessMenu = (page, type) => {
  const permissions = store.getters['Auth/me'].permissions ? store.getters['Auth/me'].permissions.filter(item => item.app_name === APP_NAME) : []
  if (!permissions || !permissions.length) {
    store.dispatch('Auth/logout')
    if (router.currentRoute.name !== 'Login') {
      router.push({ name: 'Login', replace: true })
    }
    return
  }

  const menuPermission = permissions.find(item => (item.url_name && item.url_name.toLowerCase() === page.toLowerCase()) || item.name.toLowerCase() === page.toLowerCase())
  if (menuPermission) {
    if (menuPermission.children.length) {
      return menuPermission.children.map(child => {
        if(child.children.length) return child.children.map(grandChild => grandChild.permissions.length)
        return child.permissions.length
      }).some(child => child)
    }

    return menuPermission.permissions.some(permission => permission === type)
  } else {
    let menuPermissionInChild = permissions.find(item => item.children.find(it => (it.url_name && it.url_name.toLowerCase() === page.toLowerCase()) || it.name.toLowerCase() === page.toLowerCase()))
    menuPermissionInChild = menuPermissionInChild ? menuPermissionInChild.children.find(item => (item.url_name && item.url_name.toLowerCase() === page.toLowerCase()) || item.name.toLowerCase() === page.toLowerCase()) : null

    if(menuPermissionInChild) {
      if (menuPermissionInChild.children.filter(child => child.is_feature).length) {
        return menuPermissionInChild.children.map(child => child.permissions.length).some(child => child)
      }
      const hasPermissionOnChild = menuPermissionInChild.permissions.some(permission => permission === type)
      if (hasPermissionOnChild) {
        return true
      }
      return menuPermissionInChild.children.map(child => child.permissions.some(permission => permission === type)).some(child => child)
    } else {
      let menuPermissionInGrandChild = permissions.find(item => item.children.find(it => it.children.find(it2 => (it2.url_name && it2.url_name.toLowerCase() === page.toLowerCase()) || it2.name.toLowerCase() === page.toLowerCase())))
      menuPermissionInGrandChild = menuPermissionInGrandChild ? menuPermissionInGrandChild.children.find(item => item.children.find(it => (it.url_name && it.url_name.toLowerCase() === page.toLowerCase()) || it.name.toLowerCase() === page.toLowerCase())) : null
      menuPermissionInGrandChild = menuPermissionInGrandChild ? menuPermissionInGrandChild.children.find(item => (item.url_name && item.url_name.toLowerCase() === page.toLowerCase()) || item.name.toLowerCase() === page.toLowerCase()) : null
      if(menuPermissionInGrandChild) {
        if (menuPermissionInGrandChild.children && menuPermissionInGrandChild.children.length) {
          return menuPermissionInGrandChild.children.map(child => child.permissions.length).some(child => child)
        }

        return menuPermissionInGrandChild.permissions.some(permission => permission === type)
      }
      return false
    }
  }
}

export const isUserCanAccessChildMenu = (page, childPage, type) => {

  const permissions = store.getters['Auth/me'].permissions.filter(item => item.app_name === APP_NAME)
  const menuPermission = permissions.find(item => item.name.toLowerCase() === page.toLowerCase())
  if (menuPermission) {
    const childMenu = menuPermission.children.find(child => child.name.toLowerCase() === childPage.toLowerCase())
    if(childMenu) {
      return childMenu.permissions.some(permission => permission === type)
    }
  }
  return false
}

export const isUserCanAccessGrandchildMenu = (page, childPage, grandChildPage, type) => {

  const permissions = store.getters['Auth/me'].permissions.filter(item => item.app_name === APP_NAME)
  const menuPermission = permissions.find(item => item.name.toLowerCase() === page.toLowerCase())
  if (menuPermission) {
    const childMenu = menuPermission.children.find(child => child.name.toLowerCase() === childPage.toLowerCase())
    if(childMenu) {
      const grandChildMenu = childMenu.children.find(grandChild => grandChild.name.toLowerCase() === grandChildPage.toLowerCase())
      if(grandChildMenu) {
        return grandChildMenu.permissions.some(permission => permission === type)
      }
    }
  }
  return false
}

export const isUserCanAccessFeature = () => {
  const routerName = router.currentRoute.name?.toLowerCase()
  const haveParent = router.currentRoute.meta?.permission?.name
  const permissionsType = router.currentRoute.meta?.permission?.type
  const permissions = store.getters['Auth/me'].permissions.filter(item => item.app_name === APP_NAME)

  if(!permissions?.length) {
    return { haveAccess: false, firstRouteThatHaveAccess: 'NotFound'}
  }

  // Find first route with permissions (depth-first search)
  const findFirstRoute = (items) => {
    for (const item of items) {
      if (item?.url_name && item?.permissions?.length) {
        return item
      }
      if (item?.children?.length) {
        const found = findFirstRoute(item.children)
        if (found) return found
      }
    }
    return null
  }

  // Check if item or its children match route and have permissions
  const hasMatch = (item) => {
    const isMatch = (item?.url_name?.toLowerCase() === routerName ||
        item?.url_name?.toLowerCase() === haveParent?.toLowerCase()) &&
      item?.permissions?.length

    if (isMatch) {
      return !permissionsType || item.permissions.includes(permissionsType)
    }

    return item?.children?.length ? item.children.some(hasMatch) : false
  }

  const firstRouteThatHaveAccess = findFirstRoute(permissions)

  return {
    haveAccess: permissions.some(hasMatch),
    firstRouteThatHaveAccess: firstRouteThatHaveAccess?.url_name
  }
}
